// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * UserAttributes type.
 * @typedef {object} UserAttributes
 * @property {boolean | null} active - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {Date | null} currentSignInAt - Attribute value.
 * @property {string | null} email - Attribute value.
 * @property {string | null} encryptedPassword - Attribute value.
 * @property {string | null} firstName - Attribute value.
 * @property {string} id - Attribute value.
 * @property {string | null} lastName - Attribute value.
 * @property {string | null} locale - Attribute value.
 * @property {string} name - Attribute value.
 * @property {string | null} primaryOrganizationId - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by UserCreateAttributes.
 * @typedef {object} UserCreateAttributes
 * @property {UserAttributes["active"] | null} [active] - Permitted active value.
 * @property {UserAttributes["email"] | null} [email] - Permitted email value.
 * @property {UserAttributes["encryptedPassword"] | null} [encryptedPassword] - Permitted encryptedPassword value.
 * @property {UserAttributes["firstName"] | null} [firstName] - Permitted firstName value.
 * @property {UserAttributes["lastName"] | null} [lastName] - Permitted lastName value.
 * @property {UserAttributes["locale"] | null} [locale] - Permitted locale value.
 * @property {FrontendModelAttributeValue} [password] - Permitted password value.
 * @property {UserAttributes["primaryOrganizationId"] | null} [primaryOrganizationId] - Permitted primaryOrganizationId value.
 */
/**
 * Attributes accepted by UserUpdateAttributes.
 * @typedef {object} UserUpdateAttributes
 * @property {UserAttributes["active"] | null} [active] - Permitted active value.
 * @property {UserAttributes["email"] | null} [email] - Permitted email value.
 * @property {UserAttributes["encryptedPassword"] | null} [encryptedPassword] - Permitted encryptedPassword value.
 * @property {UserAttributes["firstName"] | null} [firstName] - Permitted firstName value.
 * @property {UserAttributes["lastName"] | null} [lastName] - Permitted lastName value.
 * @property {UserAttributes["locale"] | null} [locale] - Permitted locale value.
 * @property {FrontendModelAttributeValue} [password] - Permitted password value.
 * @property {UserAttributes["primaryOrganizationId"] | null} [primaryOrganizationId] - Permitted primaryOrganizationId value.
 */
/**
 * Frontend model for User.
 * @augments {FrontendModelBase<UserAttributes, UserCreateAttributes, UserUpdateAttributes, UserAttributes["id"], string>}
 */
class User extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "User",
      attachments: {
        profilePicture: {
          sync: {
            fetch: "eager",
            offlineRequirement: "optional",
            retention: "evictable",
          },
          type: "hasOne"
        },
      },
      attributes: [
        "active",
        "createdAt",
        "currentSignInAt",
        "email",
        "encryptedPassword",
        "firstName",
        "id",
        "lastName",
        "locale",
        "name",
        "primaryOrganizationId",
        "updatedAt",
      ],
      collectionCommands: [
        "changeLocale",
        "changeTheme",
        "currentProfile",
        "signIn",
        "signOut",
        "updateProfile",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      tasks: {type: "hasMany"},
      userProjectLinks: {type: "hasMany"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      tasks: "Task",
      userProjectLinks: "UserProjectLink",
    }
  }

  /** @returns {UserAttributes["active"]} - Attribute value. */
  active() { return /** @type {UserAttributes["active"]} */ (this.readAttribute("active")) }

  /**
   * @param {UserAttributes["active"] | null} newValue - New attribute value.
   * @returns {UserAttributes["active"] | null} - Assigned value.
   */
  setActive(newValue) { return /** @type {UserAttributes["active"] | null} */ (this.setAttribute("active", newValue)) }

  /** @returns {UserAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {UserAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {UserAttributes["currentSignInAt"]} - Attribute value. */
  currentSignInAt() { return /** @type {UserAttributes["currentSignInAt"]} */ (this.readAttribute("currentSignInAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCurrentSignInAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("currentSignInAt", newValue)) }

  /** @returns {UserAttributes["email"]} - Attribute value. */
  email() { return /** @type {UserAttributes["email"]} */ (this.readAttribute("email")) }

  /**
   * @param {UserAttributes["email"] | null} newValue - New attribute value.
   * @returns {UserAttributes["email"] | null} - Assigned value.
   */
  setEmail(newValue) { return /** @type {UserAttributes["email"] | null} */ (this.setAttribute("email", newValue)) }

  /** @returns {UserAttributes["encryptedPassword"]} - Attribute value. */
  encryptedPassword() { return /** @type {UserAttributes["encryptedPassword"]} */ (this.readAttribute("encryptedPassword")) }

  /**
   * @param {UserAttributes["encryptedPassword"] | null} newValue - New attribute value.
   * @returns {UserAttributes["encryptedPassword"] | null} - Assigned value.
   */
  setEncryptedPassword(newValue) { return /** @type {UserAttributes["encryptedPassword"] | null} */ (this.setAttribute("encryptedPassword", newValue)) }

  /** @returns {UserAttributes["firstName"]} - Attribute value. */
  firstName() { return /** @type {UserAttributes["firstName"]} */ (this.readAttribute("firstName")) }

  /**
   * @param {UserAttributes["firstName"] | null} newValue - New attribute value.
   * @returns {UserAttributes["firstName"] | null} - Assigned value.
   */
  setFirstName(newValue) { return /** @type {UserAttributes["firstName"] | null} */ (this.setAttribute("firstName", newValue)) }

  /** @returns {UserAttributes["id"]} - Attribute value. */
  id() { return /** @type {UserAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {UserAttributes["id"] | null} newValue - New attribute value.
   * @returns {UserAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {UserAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {UserAttributes["lastName"]} - Attribute value. */
  lastName() { return /** @type {UserAttributes["lastName"]} */ (this.readAttribute("lastName")) }

  /**
   * @param {UserAttributes["lastName"] | null} newValue - New attribute value.
   * @returns {UserAttributes["lastName"] | null} - Assigned value.
   */
  setLastName(newValue) { return /** @type {UserAttributes["lastName"] | null} */ (this.setAttribute("lastName", newValue)) }

  /** @returns {UserAttributes["locale"]} - Attribute value. */
  locale() { return /** @type {UserAttributes["locale"]} */ (this.readAttribute("locale")) }

  /**
   * @param {UserAttributes["locale"] | null} newValue - New attribute value.
   * @returns {UserAttributes["locale"] | null} - Assigned value.
   */
  setLocale(newValue) { return /** @type {UserAttributes["locale"] | null} */ (this.setAttribute("locale", newValue)) }

  /** @returns {UserAttributes["name"]} - Attribute value. */
  name() { return /** @type {UserAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {UserAttributes["name"] | null} newValue - New attribute value.
   * @returns {UserAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {UserAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {UserAttributes["primaryOrganizationId"]} - Attribute value. */
  primaryOrganizationId() { return /** @type {UserAttributes["primaryOrganizationId"]} */ (this.readAttribute("primaryOrganizationId")) }

  /**
   * @param {UserAttributes["primaryOrganizationId"] | null} newValue - New attribute value.
   * @returns {UserAttributes["primaryOrganizationId"] | null} - Assigned value.
   */
  setPrimaryOrganizationId(newValue) { return /** @type {UserAttributes["primaryOrganizationId"] | null} */ (this.setAttribute("primaryOrganizationId", newValue)) }

  /** @returns {UserAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {UserAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Runs changeLocale.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{locale: string}>} - Command response.
   */
  static async changeLocale(...commandArguments) {
    return /** @type {{locale: string}} */ (await this.executeCustomCommand({
      commandName: "change-locale",
      commandType: "change-locale",
      payload: User.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs changeTheme.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{theme: string}>} - Command response.
   */
  static async changeTheme(...commandArguments) {
    return /** @type {{theme: string}} */ (await this.executeCustomCommand({
      commandName: "change-theme",
      commandType: "change-theme",
      payload: User.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs currentProfile.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/user-profile-command-types.js").UserCurrentProfileResponse>} - Command response.
   */
  static async currentProfile(...commandArguments) {
    return /** @type {import("../../../shared/user-profile-command-types.js").UserCurrentProfileResponse} */ (await this.executeCustomCommand({
      commandName: "current-profile",
      commandType: "current-profile",
      payload: User.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs signIn.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{sessionToken: string, sessionExpiresAt: string, user: {email: string | null, id: string | number}}>} - Command response.
   */
  static async signIn(...commandArguments) {
    return /** @type {{sessionToken: string, sessionExpiresAt: string, user: {email: string | null, id: string | number}}} */ (await this.executeCustomCommand({
      commandName: "sign-in",
      commandType: "sign-in",
      payload: User.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs signOut.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{ok: true}>} - Command response.
   */
  static async signOut(...commandArguments) {
    return /** @type {{ok: true}} */ (await this.executeCustomCommand({
      commandName: "sign-out",
      commandType: "sign-out",
      payload: User.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs updateProfile.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/user-profile-command-types.js").UserUpdateProfileResponse>} - Command response.
   */
  static async updateProfile(...commandArguments) {
    return /** @type {import("../../../shared/user-profile-command-types.js").UserUpdateProfileResponse} */ (await this.executeCustomCommand({
      commandName: "update-profile",
      commandType: "update-profile",
      payload: User.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns tasks relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<User, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} - Relationship helper.
   */
  tasksRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<User, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} */ (this.getRelationshipByName("tasks")) }

  /**
   * Returns tasks.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<User, import("./task.js").Task, import("./task.js").TaskCreateAttributes>} - Relationship helper.
   */
  tasks() { return this.tasksRelationship() }

  /**
   * Returns loaded tasks.
   * @returns {Array<import("./task.js").Task>} - Loaded related models.
   */
  tasksLoaded() { return this.tasksRelationship().loaded() }

  /**
   * Loads tasks.
   * @returns {Promise<Array<import("./task.js").Task>>} - Loaded related models.
   */
  async loadTasks() { return await this.tasksRelationship().load() }

  /**
   * Returns userProjectLinks relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<User, import("./user-project-link.js").UserProjectLink, import("./user-project-link.js").UserProjectLinkCreateAttributes>} - Relationship helper.
   */
  userProjectLinksRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<User, import("./user-project-link.js").UserProjectLink, import("./user-project-link.js").UserProjectLinkCreateAttributes>} */ (this.getRelationshipByName("userProjectLinks")) }

  /**
   * Returns userProjectLinks.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<User, import("./user-project-link.js").UserProjectLink, import("./user-project-link.js").UserProjectLinkCreateAttributes>} - Relationship helper.
   */
  userProjectLinks() { return this.userProjectLinksRelationship() }

  /**
   * Returns loaded userProjectLinks.
   * @returns {Array<import("./user-project-link.js").UserProjectLink>} - Loaded related models.
   */
  userProjectLinksLoaded() { return this.userProjectLinksRelationship().loaded() }

  /**
   * Loads userProjectLinks.
   * @returns {Promise<Array<import("./user-project-link.js").UserProjectLink>>} - Loaded related models.
   */
  async loadUserProjectLinks() { return await this.userProjectLinksRelationship().load() }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(User)

export {User}

export default User
